import { getJourneySessionId } from "@/lib/journey-analytics";

export const VIDEO_MEASUREMENT_CONTRACT = "video_v2";
export const VIDEO_PROGRESS_MILESTONES = [25, 50, 75, 90] as const;

export type VideoPlayerSurface =
  | "video_page"
  | "library_preview"
  | "embedded_note";

export type VideoAnalyticsContext = {
  videoSlug: string;
  videoTitle: string;
  videoSubject?: string | null;
  videoContentType: string;
  videoDurationSeconds?: number;
  sourcePage: string;
  sourceSurface: string;
  playerSurface: VideoPlayerSurface;
  resultRank?: number;
  studySubject?: string;
  studyTopic?: string;
  studyVideoMatchQuality?: "topic" | "related" | null;
};

export function createVideoPlaybackId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }

  return `video-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function buildVideoAnalyticsParams(
  context: VideoAnalyticsContext,
  playbackId: string,
  runtime?: {
    elapsedSeconds?: number;
    maxProgressPercent?: number;
    progressPercent?: number;
  }
): Record<string, unknown> {
  return {
    journey_session_id: getJourneySessionId() ?? undefined,
    measurement_contract: VIDEO_MEASUREMENT_CONTRACT,
    playback_id: playbackId,
    video_slug: context.videoSlug,
    video_title: context.videoTitle,
    video_subject: context.videoSubject ?? undefined,
    video_content_type: context.videoContentType,
    video_duration_seconds: context.videoDurationSeconds,
    source_page: context.sourcePage,
    source_surface: context.sourceSurface,
    player_surface: context.playerSurface,
    result_rank: context.resultRank,
    study_subject: context.studySubject,
    study_topic: context.studyTopic,
    study_video_match_quality: context.studyVideoMatchQuality ?? undefined,
    elapsed_seconds: runtime?.elapsedSeconds,
    max_progress_percent: runtime?.maxProgressPercent,
    progress_percent: runtime?.progressPercent,
  };
}
